// extracted by mini-css-extract-plugin
module.exports = {"image":"OverlayLogoImage_image__AHWd9"};